import React from "react";
import "./educationalvideo.scss";
import Navbar from "../landing/header/Navbar";
import Footer from "../landing/Footer/Footer";
const Educationalvideo = () => {
  return (
    <>
      <Navbar />
      <section className="main_educatinal_videos">
        <div className="custom-container">
          <div className="innner_educational_videos">
            <h2>Educational Videos</h2>
            <p>
              Watch our comprehensive video tutorials to learn everything about
              GEMS tokens.
            </p>
            <div className="tabs_style">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    All
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                  >
                    Trading Strategies
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="contact-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#contact"
                    type="button"
                    role="tab"
                    aria-controls="contact"
                    aria-selected="false"
                  >
                    Market Analysis
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="guides-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#guides"
                    type="button"
                    role="tab"
                    aria-controls="guides"
                    aria-selected="false"
                  >
                    Platform Guides
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="wallet-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#wallet"
                    type="button"
                    role="tab"
                    aria-controls="wallet"
                    aria-selected="false"
                  >
                    Security & Wallet
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="basics-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#basics"
                    type="button"
                    role="tab"
                    aria-controls="basics"
                    aria-selected="false"
                  >
                    Beginner Basics
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="ecosystem-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#ecosystem"
                    type="button"
                    role="tab"
                    aria-controls="ecosystem"
                    aria-selected="false"
                  >
                    Ecosystem
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="update-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#update"
                    type="button"
                    role="tab"
                    aria-controls="update"
                    aria-selected="false"
                  >
                    New&update
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="market-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#market"
                    type="button"
                    role="tab"
                    aria-controls="market"
                    aria-selected="false"
                  >
                    Market Analysis
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="markets-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#markets"
                    type="button"
                    role="tab"
                    aria-controls="markets"
                    aria-selected="false"
                  >
                    Market Analysis
                  </button>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="cards_parent">
                    <div className="cardsone">
                      <div className="imgdiv">
                        <img className="imgbgg" src="\assets\cardsimg.png" />
                        <span className="topleft">Beginner</span>
                        <img className="imgplay" src="\assets\play.png" />
                        <span className="time">3:45</span>
                      </div>

                      <div className="inner_cards">
                        <h3>Getting Started with GEMS</h3>
                        <h4>
                          Learn the basics of purchasing and managing your GEMS
                          tokens. This tutorial covers everything...
                        </h4>
                      </div>
                    </div>
                    <div className="cardsone">
                      <div className="imgdiv">
                        <img className="imgbgg" src="\assets\cardtwo.png" />
                        <span className="topleft">Beginner</span>
                        <img className="imgplay" src="\assets\play.png" />
                        <span className="time">3:45</span>
                      </div>

                      <div className="inner_cards">
                        <h3>How to Connect Your Wallet</h3>
                        <h4>
                          Step-by-step guide to connecting your cryptocurrency wallet. We cover MetaMask, WalletConnect, and...
                        </h4>
                      </div>
                    </div>
                    <div className="cardsone">
                      <div className="imgdiv">
                        <img className="imgbgg" src="\assets\cardthree.png" />
                        <span className="topleft">Beginner</span>
                        <img className="imgplay" src="\assets\play.png" />
                        <span className="time">3:45</span>
                      </div>

                      <div className="inner_cards">
                        <h3>Understanding Token Sale Rounds</h3>
                        <h4>
                          Everything you need to know about our token sale structure, including pricing tiers, special offers...
                        </h4>
                      </div>
                    </div>
                    <div className="cardsone">
                      <div className="imgdiv">
                        <img className="imgbgg" src="\assets\cardfour.png" />
                        <span className="topleft">Beginner</span>
                        <img className="imgplay" src="\assets\play.png" />
                        <span className="time">3:45</span>
                      </div>

                      <div className="inner_cards">
                        <h3>Security Best Practices</h3>
                        <h4>
                          Tips to keep your crypto assets safe and secure. Learn about private key management, phishing preven...
                        </h4>
                      </div>
                    </div>
                    <div className="cardsone">
                      <div className="imgdiv">
                        <img className="imgbgg" src="\assets\cardfive.png" />
                        <span className="topleft">Beginner</span>
                        <img className="imgplay" src="\assets\play.png" />
                        <span className="time">3:45</span>
                      </div>

                      <div className="inner_cards">
                        <h3>Reading and Understanding Transaction</h3>
                        <h4>
                          Learn how to verify your transactions on Etherscan, understand gas fees, and track your token purchases.
                        </h4>
                      </div>
                    </div>
                    <div className="cardsone">
                      <div className="imgdiv">
                        <img className="imgbgg" src="\assets\cardsix.png" />
                        <span className="topleft">Beginner</span>
                        <img className="imgplay" src="\assets\play.png" />
                        <span className="time">3:45</span>
                      </div>

                      <div className="inner_cards">
                        <h3>Maximizing Your Token Purchase</h3>
                        <h4>
                          Discover strategies for taking advantage of special offers, timing your purchases, and optimizing fo...                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="contact"
                  role="tabpanel"
                  aria-labelledby="contact-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="guides"
                  role="tabpanel"
                  aria-labelledby="guides-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="wallet"
                  role="tabpanel"
                  aria-labelledby="wallet-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="basics"
                  role="tabpanel"
                  aria-labelledby="basics-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="ecosystem"
                  role="tabpanel"
                  aria-labelledby="ecosystem-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="update"
                  role="tabpanel"
                  aria-labelledby="update-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="market"
                  role="tabpanel"
                  aria-labelledby="market-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="markets"
                  role="tabpanel"
                  aria-labelledby="markets-tab"
                >
                  ...
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Educationalvideo;
